import { ReactNode } from "react";

import { SxProps, Theme, alpha, styled } from "@mui/material";
import Box from "@mui/material/Box";

const StyledBoxWrapper = styled(Box)(({ theme }) => ({
	margin: 0,

	"& .MuiDataGrid-root": {
		border: "none",
		backgroundColor: theme.palette.background.paper,
	},

	"& .MuiDataGrid-cell": {
		borderBottom: `1px solid ${alpha(theme.palette.divider, 0.8)}`,
		whiteSpace: "normal !important",
		wordWrap: "break-word !important",
	},

	"& .name-column--cell": {
		/* Styles for specific column if needed */
	},

	"& .MuiDataGrid-columnHeaders": {
		borderBottom: `1px solid ${theme.palette.divider}`,
		backgroundColor:
			theme.palette.mode === "dark"
				? alpha(theme.palette.common.white, 0.03)
				: theme.palette.grey[50],
	},

	"& .MuiDataGrid-columnHeaderTitle": {
		fontWeight: 600,
	},

	"& .MuiDataGrid-footerContainer": {
		borderTop: `1px solid ${theme.palette.divider}`,
		backgroundColor:
			theme.palette.mode === "dark"
				? alpha(theme.palette.common.white, 0.03)
				: theme.palette.grey[50],
	},

	"& .MuiCheckbox-root": {
		/* Checkbox styles if needed */
	},
}));

type TableContainerProps = {
	children?: ReactNode;
	height?: number | string;
	sx?: SxProps<Theme>;
};

const TableContainer = ({ children, height, sx }: TableContainerProps) => {
	return (
		<StyledBoxWrapper
			height={height}
			sx={{
				// allow this to be the scrollable flex child
				flex: 1,
				minHeight: 0,
				overflowY: "auto",
				overflowX: "auto",
				WebkitOverflowScrolling: "touch",
				...(height ? { height } : {}),
				...sx,
			}}
		>
			{children}
		</StyledBoxWrapper>
	);
};

export default TableContainer;
